import React, { useState } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { combineClassNames } from '../../../core/css';
import Categories from './Categories';

const OptionTabs = ({ tabs, breakpoint, analyticsKey }) => {
  const tabsContents = tabs.map((tab) => {
    return {
      key: tab.key,
      tabLabel: tab.shortLabel.toLowerCase(),
      categories: tab.categories,
      hasMostPopular: !!tab.categories.filter((x) => x.key === 'most.popular')
        .length,
    };
  });

  const defaultSelectedIndex = tabs.findIndex((tab) => {
    return tab.selected;
  });

  const [selectedTabIndex, setSelectedTabIndex] = useState(
    defaultSelectedIndex === -1 ? 0 : defaultSelectedIndex
  );

  const onSelect = (tabIndex) => setSelectedTabIndex(tabIndex);

  return (
    <Tabs
      selectedIndex={selectedTabIndex}
      onSelect={(tabIndex) => onSelect(tabIndex)}
      selectedTabClassName="option-tabs__tab--active">
      <TabList
        className={combineClassNames(
          'option-tabs__tablist',
          'option-tabs__tablist--sticky'
        )}>
        {tabs.map((tab, index) => (
          <Tab
            key={tab.key}
            className={combineClassNames(
              'stat-button-link',
              'option-tabs__tab'
            )}
            data-dtm={analyticsKey}>
            <div
              className={combineClassNames(
                'option-tabs__label-outer',
                index === selectedTabIndex
                  ? 'option-tabs__label-outer--active'
                  : ''
              )}>
              <span className="option-tabs__label">
                {breakpoint === 'small' || breakpoint === 'xsmall'
                  ? tab.shortLabel
                  : tab.label}
              </span>
            </div>
          </Tab>
        ))}
      </TabList>
      {tabsContents.map((tabsContent) => (
        <TabPanel className="option-tab__content" key={tabsContent.key}>
          <Categories
            categories={tabsContent.categories}
            analyticsKey={`${analyticsKey}:${tabsContent.tabLabel}`}></Categories>
        </TabPanel>
      ))}
    </Tabs>
  );
};

export default OptionTabs;
